module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div id="drag_drop_container">\n	<form id="drag_drop_form" action="/upload" method="post" enctype="multipart/form-data">\n		<div class="drag_drop_title_wrapper">\n			<p id="drag_drop_title"">\n				';
 if (gon.isMobile) { ;
__p += '\n					' +
((__t = ( I18n.t('uploader.source.drag_drop.title_mobile') )) == null ? '' : __t) +
'\n				';
 } else { ;
__p += '\n					' +
((__t = ( I18n.t('uploader.source.drag_drop.title_desktop') )) == null ? '' : __t) +
'\n				';
 } ;
__p += '\n				<span>\n					';
 if (gon.isMobile) { ;
__p += '\n						' +
((__t = ( I18n.t('uploader.source.drag_drop.full_label_mobile', {
								label_1: I18n.t('uploader.source.drag_drop.label_1_mobile'),
								label_3: I18n.t('uploader.source.drag_drop.label_3_mobile')
						}) )) == null ? '' : __t) +
'\n					';
 } else { ;
__p += '\n						' +
((__t = ( I18n.t('uploader.source.drag_drop.full_label_desktop_html', {
								label_1: I18n.t('uploader.source.drag_drop.label_1_desktop'),
								label_2: I18n.t('uploader.source.drag_drop.label_2_desktop'),
								label_3: I18n.t('uploader.source.drag_drop.label_3_desktop')
						}) )) == null ? '' : __t) +
'\n					';
 } ;
__p += '\n				</span>\n			</p>\n		</div>\n		<input type="hidden" name="key">\n		<input type="hidden" name="policy">\n		<input type="hidden" name="acl" value="public-read">\n		<input type="hidden" name="signature">\n		<input type="hidden" name="Content-Type">\n		<input type="hidden" name="AWSAccessKeyId">\n		<input type="hidden" name="success_action_status" value="201">\n		<input style="visibility: hidden; height: 0;" type="file" name="file" id="file_input" multiple="">\n		<button id="fileuploader" title="' +
((__t = ( I18n.t('uploader.source.drag_drop.file_picker') )) == null ? '' : __t) +
'">' +
((__t = ( I18n.t('uploader.source.drag_drop.file_picker') )) == null ? '' : __t) +
'</button>\n	</form>\n</div>\n';

}
return __p
}